import React from 'react';
import DocsLink from '../../../common/custom/DocsLink';

const AmazonSes = () => {
  return (
    <>
      <h5>
        <b>Amazon SES</b>
      </h5>
      <p>
        Amazon's Simple Email Service (SES) is a flexible email service platform that allows you to
        send and recieve emails via custom domains and email addresses.
      </p>
      <DocsLink link="https://academy.drapcode.com/docs/app-plugin/aws-ses-plugin" />
    </>
  );
};

export default AmazonSes;
